import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import {
  MASS_OS_FILE_STATES,
  MassOsFilterOptions,
  MassOsFiltersState
} from 'src/entities/file';

@Component({
  selector: 'app-mass-os-filters',
  templateUrl: './mass-os-filters.component.html',
  styleUrls: ['./mass-os-filters.component.css']
})
export class MassOsFiltersComponent {
  @Input() fileControl!: FormControl;
  @Input() filteredOptions!: Observable<any[]>;
  @Input() showServiceFilters = false;
  @Input() filters: MassOsFiltersState = {
    day: null,
    typeOfService: null,
    categoryOfService: null,
    serviceName: null,
    client: null,
    orderNumber: null,
    estadoFile: null,
    startDate: null,
    endDate: null
  };
  @Input() filterOptions: MassOsFilterOptions = {
    days: [],
    typesOfService: [],
    categoriesByType: [],
    services: [],
    orderNumbers: [],
    clients: []
  };
  @Input() categoriesForTipo: string[] = [];
  @Input() searchValue = '';
  /** Texto del panel de filtros (OS vs NP). */
  @Input() filtersPanelHint =
    'Afina la grilla antes de generar OS.';
  /** NP Masivas: el tipo ya está fijado a Alimentos. */
  @Input() hideTypeOfServiceFilter = false;
  /** NP Masivas: no aplica filtro N° OS. */
  @Input() hideOrderNumberFilter = false;

  @Output() fileSelected = new EventEmitter<void>();
  @Output() filtersChange = new EventEmitter<MassOsFiltersState>();
  @Output() searchChange = new EventEmitter<string>();
  @Output() clearDateRange = new EventEmitter<void>();

  readonly fileStates = MASS_OS_FILE_STATES;

  displayFileOption = (option: any): string => {
    if (!option?.fileNumber) {
      return '';
    }
    return `${option.fileNumber}${option.fileExtend ? ' ' + option.fileExtend : ''}`;
  };

  onFilterFieldChange(patch: Partial<MassOsFiltersState>): void {
    this.filtersChange.emit({ ...this.filters, ...patch });
  }

  onApplyDateRange(): void {
    if (!this.filters.startDate || !this.filters.endDate) {
      return;
    }
    this.filtersChange.emit({ ...this.filters });
  }

  onSearch(value: string): void {
    this.searchChange.emit(value);
  }
}
